var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2056 10.0838C34.3541 12.5819 36.0476 15.4377 37.2091 18.5212C38.5637 22.0791 39.25 25.9406 39.25 30C39.25 38.2706 32.5206 45 24.25 45C15.9794 45 9.25 38.2706 9.25 30C9.25 25.7128 11.6875 21.9713 14.0509 18.3488L14.0515 18.348C16.9041 13.9748 19.599 9.84345 18.2987 4.875C18.1828 4.42599 18.2811 3.9486 18.5649 3.58188C18.8488 3.21516 19.2863 3.00035 19.75 3C23.5984 3 28.4875 5.77969 32.2056 10.0838ZM24.25 40.5C25.0984 40.5 26.3125 40.2834 27.2809 39.2522C28.2419 38.2284 28.75 36.585 28.75 34.5C28.75 32.2894 27.7347 29.625 26.0312 27.375C25.3852 26.5044 24.6228 25.7265 23.7653 25.0631C23.5639 24.9155 23.3021 24.8778 23.0672 24.9626C22.8323 25.0474 22.655 25.2436 22.5944 25.4859C22.3146 26.5772 21.8445 27.597 21.3828 28.5989L21.3756 28.6144L21.3745 28.6167C20.5761 30.3504 19.75 32.1442 19.75 34.5C19.75 36.585 20.2506 38.2209 21.2191 39.2522C22.1875 40.2834 23.4016 40.5 24.25 40.5Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gas-icon.a4c791853ba9985c47d98000d4f7dfcb.svg";
export { ForwardRef as ReactComponent };